import { render, staticRenderFns } from "./myRevHome.vue?vue&type=template&id=bb2f49e8"
import script from "./myRevHome.vue?vue&type=script&lang=js"
export * from "./myRevHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports